import { render } from "./SignUpReportCancelledModal.vue?vue&type=template&id=b97d09b0&ts=true"
import script from "./SignUpReportCancelledModal.vue?vue&type=script&lang=ts"
export * from "./SignUpReportCancelledModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__